<div class="promo-t6-page">
    <!-- =========================================
       ENCABEZADO
  ========================================== -->
    <section class="promo-t6-header">
        <span class="promo-t6-eyebrow">
            PROMOCIÓN
        </span>
        <h1 class="promo-t6-title">
            Código promocional
        </h1>
        <p class="promo-t6-subtitle">
            {{ promo }}
        </p>
    </section>
    <!-- =========================================
       CONTENIDO
  ========================================== -->
    <section class="promo-t6-content">
        <!-- PRODUCTOS -->
        <div class="promo-t6-products" *ngIf="products.length > 0">
            <article class="promo-t6-card" [class.selected]="product.selected" *ngFor="let product of products"
                (click)="selectedProduct(product)">
                <div class="promo-t6-image">
                    <img [src]="product.urlFoto" [defaultImage]="defImgProd"
                        [alt]="product.productoAgrupador || product.producto">
                </div>
                <div class="promo-t6-card-content">
                    <h3>
                        {{ product.producto }}
                    </h3>
                    <div class="promo-t6-check" *ngIf="product.selected">
                        <mat-icon>
                            check_circle
                        </mat-icon>
                    </div>
                </div>
            </article>
        </div>
        <!-- =========================================
         PANEL CÓDIGO
    ========================================== -->
        <aside class="promo-t6-panel">
            <div class="promo-t6-panel-content">
                <span class="promo-t6-panel-eyebrow">
                    CANJEA TU PROMOCIÓN
                </span>
                <h2>
                    Ingresa tu código
                </h2>
                <p>
                    Selecciona un producto y escribe el código promocional que recibiste.
                </p>
                <div class="promo-t6-code-input">
                    <input class="promo-t6-code-native" type="text" placeholder="Código promocional" maxlength="10"
                        [(ngModel)]="code" (input)="onCodeInput($event)" pattern="[A-Z0-9]*">
                </div>
                <button class="promo-t6-button" mat-raised-button type="button" (click)="canjear()"
                    [disabled]="code.length === 0 || btnDisabled">
                    CANJEAR
                </button>
            </div>
        </aside>
    </section>
</div>